export const locales = [
    {
        locale: 'English',
        localeId: ['en-AU', 'en-GB'][0]
    },
    {
        locale: 'Spanish',
        localeId: 'es'
    },
    {
        locale: 'Portuguese',
        localeId: ['pt-BR', 'pt-PT'][0]
    },
    {
        locale: 'German',
        localeId: ['de-DE', 'de-AT', 'de-LI', 'de-LU', 'de-CH'][0]
    },
    
];